<div class="card modern-card full-width">
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h1 class="modern-header">Distributor Management</h1>
      </div>
    </div>
  </div>

  <div class="card-body px-4 pb-4">
    <div class="row w-100 m-0">
      <!-- Left Column: Options & Selection -->
      <div class="col-md-5 border-end border-secondary pe-4">
        <div class="mb-4">
          <label
            class="form-label mb-2 text-light"
            style="width: 100%; text-align: left"
            >Management Options</label
          >
          <ng-select
            class="themed-select management-select"
            [items]="management_options"
            [searchable]="false"
            [clearable]="false"
            [multiple]="false"
            placeholder="Select Management Options"
            aria-label="Management option"
            [(ngModel)]="selected_management_option"
            (ngModelChange)="onManagementOptionChange($event)"
          ></ng-select>
        </div>

        @if (selected_management_option == "Distributor Credentials") {
          <div class="mb-4 pt-4 border-top border-secondary">
            <label
              class="form-label mb-2 text-light"
              style="width: 100%; text-align: left"
              >Select Distributor</label
            >
            <div class="d-flex gap-2">
              <ng-select
                class="themed-select distributor-select flex-grow-1"
                [items]="distributor_api_list"
                bindLabel="value"
                bindValue="name"
                [searchable]="false"
                [clearable]="false"
                [multiple]="false"
                placeholder="Choose a distributor"
                aria-label="Distributor"
                [(ngModel)]="selected_distributor"
                (ngModelChange)="onDistributorChange($event)"
              ></ng-select>
              @if (selected_distributor) {
                <button
                  class="btn modern-btn grey-btn"
                  (click)="AddDistributorClick()"
                >
                  Add
                </button>
              }
            </div>
          </div>
        }

        @if (selected_management_option == "Live Inventory Accounts") {
          <div class="distributor-info-alert mt-3" role="status">
            <i class="fa-solid fa-circle-info distributor-info-icon"></i>
            <span>
              Please select the distributors that you have accounts with. These
              selections will filter live inventory results.
            </span>
          </div>
        }
      </div>

      <!-- Right Column: Configurations -->
      <div class="col-md-7 ps-4">
        @if (
          configs.controls.length > 0 &&
          selected_management_option == "Distributor Credentials"
        ) {
          <form [formGroup]="distributor_config_form" autocomplete="off">
            <div formArrayName="configs">
              @for (config of configs.controls; track config; let i = $index) {
                <div
                  [formGroupName]="i"
                  class="card bg-dark-subtle border-secondary mb-3 modern-inner-card"
                >
                  <div class="card-body p-3 position-relative">
                    <!-- Distributor Name -->
                    <div class="form-group d-flex align-items-center mb-3">
                      <label
                        class="form-label text-dark"
                        [for]="'distributor_name-' + i"
                        >Distributor Name:</label
                      >
                      <input
                        class="form-control flex-grow-1"
                        type="text"
                        [id]="'distributor_name-' + i"
                        formControlName="distributor_name"
                      />
                      <button
                        type="button"
                        class="btn green-btn ms-2"
                        style="width: 140px"
                        [disabled]="!distributor_config_form.valid"
                        (click)="saveDistributionConfig(i)"
                      >
                        <i class="fa fa-save me-2"></i> Save
                      </button>
                      <button
                        type="button"
                        class="btn red-btn ms-2"
                        (click)="removeDistributor(i)"
                      >
                        Remove
                      </button>
                    </div>

                    <!-- Username -->
                    @if (configs.controls[i].get("username").value != null) {
                      <div class="form-group d-flex align-items-center mb-3">
                        <label
                          class="form-label"
                          style="color: black"
                          [for]="'username-' + i"
                          >Username:</label
                        >
                        <input
                          class="form-control flex-grow-1"
                          type="text"
                          [id]="'username-' + i"
                          formControlName="username"
                        />
                      </div>
                    }

                    <!-- Password -->
                    @if (configs.controls[i].get("password").value != null) {
                      <div class="form-group d-flex align-items-center mb-3">
                        <label
                          class="form-label"
                          style="color: black"
                          [for]="'password-' + i"
                          >Password:</label
                        >
                        <input
                          class="form-control flex-grow-1"
                          type="text"
                          [id]="'password-' + i"
                          formControlName="password"
                        />
                      </div>
                    }

                    <!-- SID -->
                    @if (configs.controls[i].get("sid").value != null) {
                      <div class="form-group d-flex align-items-center mb-3">
                        <label class="form-label text-dark" [for]="'sid-' + i"
                          >SID:</label
                        >
                        <input
                          class="form-control flex-grow-1"
                          type="text"
                          [id]="'sid-' + i"
                          formControlName="sid"
                        />
                      </div>
                    }

                    <!-- Token -->
                    @if (configs.controls[i].get("token").value != null) {
                      <div class="form-group d-flex align-items-center mb-3">
                        <label class="form-label text-dark" [for]="'token-' + i"
                          >Token:</label
                        >
                        <input
                          class="form-control flex-grow-1"
                          type="text"
                          [id]="'token-' + i"
                          formControlName="token"
                        />
                      </div>
                    }

                    <div
                      class="d-flex justify-content-between text-muted small mt-2 pt-2 border-top border-secondary"
                    >
                      <span
                        >Updated by:
                        {{
                          selected_distributor_list[i].updated_by || "N/A"
                        }}</span
                      >
                      <span
                        >Last Modified:
                        {{
                          selected_distributor_list[i].updated_datetime
                            | date: "MM/dd/yyyy, h:mm a"
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              }
            </div>
          </form>
        } @else if (selected_management_option == "Live Inventory Accounts") {
          <div class="card bg-dark-subtle border-secondary p-4">
            <h5 class="text-light mb-3">Enabled Distributors</h5>
            <div class="row">
              @for (
                distributor of distributor_inventory_list;
                track distributor;
                let i = $index
              ) {
                <div class="col-md-6 mb-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="distributor-{{ i }}"
                      [checked]="isDistributorSelected(distributor.name)"
                      (click)="selectInventoryDistributor($event, i)"
                    />
                    <label
                      class="form-check-label text-dark"
                      for="distributor-{{ i }}"
                    >
                      {{ distributor.value }}
                    </label>
                  </div>
                </div>
              }
            </div>
          </div>
        } @else {
          <div
            class="h-100 d-flex flex-column align-items-center justify-content-center text-light py-5"
          >
            <i class="fa fa-arrow-left fa-3x mb-3"></i>
            <h5>Select a management option to begin</h5>
            <p>
              Choose an option from the sidebar to manage your distributors.
            </p>
          </div>
        }
      </div>
    </div>
  </div>
</div>

